// extracted by mini-css-extract-plugin
export default {"aboutTitle":"AboutTitleComponent_aboutTitle__NRgyC"};